import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

// Page-local UI state for the AdvancedSearch page. Differs from the rule-editor
// slice in two ways:
//   - tracks `ruleId` here because the page MINTs a new rule on mount (the
//     /advanced-search route has no :id), and that id must flow into
//     QueryBuilder + the filter-results table.
//   - `applyNonce` is the testRunNonce equivalent: Apply Filter bumps it and the
//     results table reacts.

export const ADVANCED_SEARCH_REDUCER_NAME = "advanced-search";

const initialState = {
  ruleId: null,
  // Increments on each Apply Filter click; FilterResultsTable gates its results
  // query on a non-zero value.
  applyNonce: 0,
  filterTablePage: 0,
  filterTableTake: 20,
};

const advancedSearchSlice = createSlice({
  name: ADVANCED_SEARCH_REDUCER_NAME,
  initialState,
  reducers: {
    setAdvancedSearchRuleId: (state, { payload }) => {
      state.ruleId = payload;
    },
    triggerApplyFilter: (state) => {
      state.applyNonce += 1;
      state.filterTablePage = 0;
    },
    setFilterTablePage: (state, { payload }) => {
      state.filterTablePage = payload;
    },
    setFilterTableTake: (state, { payload }) => {
      state.filterTableTake = payload;
      state.filterTablePage = 0;
    },
    clearAdvancedSearch: () => ({ ...initialState }),
  },
});

export const {
  setAdvancedSearchRuleId,
  triggerApplyFilter,
  setFilterTablePage,
  setFilterTableTake,
  clearAdvancedSearch,
} = advancedSearchSlice.actions;

export default advancedSearchSlice.reducer;

export const useSelectAdvancedSearchRuleId = () =>
  useSelector((s) => s[ADVANCED_SEARCH_REDUCER_NAME].ruleId);

export const useSelectApplyNonce = () =>
  useSelector((s) => s[ADVANCED_SEARCH_REDUCER_NAME].applyNonce);

export const useSelectFilterTablePage = () =>
  useSelector((s) => s[ADVANCED_SEARCH_REDUCER_NAME].filterTablePage);

export const useSelectFilterTableTake = () =>
  useSelector((s) => s[ADVANCED_SEARCH_REDUCER_NAME].filterTableTake);
